import {isFeatureEnabled} from '@github-ui/feature-flags'
import {Spinner} from '@primer/react'
import {clsx} from 'clsx'

import {TEST_IDS} from '../../constants/test-ids'
import styles from './TimelineDivider.module.css'

type TimelineDividerProps = {
  isLoading?: boolean
  isHovered?: boolean
  id?: string
  /**
   * Hides the divider's own 2px vertical connector (`Box_1`). Under
   * `primer_react_timeline_list_semantics` the divider renders inside the event
   * `<li>`, whose Primer `Timeline.Item` already paints a full-height `::before`
   * rail at the row's left edge. Keeping `Box_1` would add a second, horizontally
   * offset segment, so the flag-on consumer suppresses it while preserving the
   * flex geometry (the box stays 2px wide, just transparent). Flag-off callers
   * omit this, so their divider is byte-for-byte unchanged.
   */
  suppressRail?: boolean
}

export const TimelineDivider = ({isLoading, isHovered, id, suppressRail}: TimelineDividerProps) => (
  <div
    data-testid={id ? TEST_IDS.timelineDivider(id) : undefined}
    className={clsx(
      styles.Box,
      isFeatureEnabled('issue_inline_avatars') && styles.Box_inlineAvatars,
      isLoading && styles.loading,
    )}
  >
    {isLoading ? (
      <Spinner size={'small'} />
    ) : (
      <>
        <div className={clsx(styles.Box_1, suppressRail && styles.Box_1_suppressed)} />
        <div className={clsx(styles.Box_2, isHovered && styles.hovered)} />
      </>
    )}
  </div>
)
